import { render, staticRenderFns } from "./labourServices.vue?vue&type=template&id=7db47524&scoped=true&"
import script from "./labourServices.vue?vue&type=script&lang=js&"
export * from "./labourServices.vue?vue&type=script&lang=js&"
import style0 from "./labourServices.vue?vue&type=style&index=0&id=7db47524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db47524",
  null
  
)

export default component.exports